import Http from '@/api/http/';

export default class PayCCostSheet extends Http {
  /**
   * C端成本单列表
   * @param {integer} ledgerVoucherStatus -  凭证状态0未推送1推送中2成功3失败
   * @param {string} pushYmdEnd -  推送日期结束y-m-d
   * @param {string} pushYmdStart -  推送日期开始y-m-d
   * @param {integer} page -  页数
   * @param {integer} rows -  页面容量
   * @param {string} ym -  月份
   */
  payCCostSheet_getPayCCostSheetList() {
    return super.post('payCCostSheet/getPayCCostSheetList', ...arguments);
  }

  /**
   * 推送C端成本单
   * @param {string} payCCostSheetId -  payCCostSheetId
   */
  payCCostSheet_pushPayCCostSheetToCrm() {
    return super.post('payCCostSheet/pushPayCCostSheetToCrm', ...arguments);
  }

  /**
   * C端成本单明细
   * @param {integer} page -  页数
   * @param {integer} rows -  页面容量
   * @param {integer} payCCostSheetId -  C端成本单id
   */
  payCCostSheet_getPayCCostSheetDetailList() {
    return super.post('payCCostSheet/getPayCCostSheetDetailList', ...arguments);
  }

  /**
   * 导出C端成本单明细
   * @param {integer} payCCostSheetId -  C端成本单id
   */
  payCCostSheet_exportPayCCostSheetDetail() {
    return super.post('payCCostSheet/exportPayCCostSheetDetail', ...arguments);
  }
}
